// V1 bug silhouette — oval body + two narrow wings angled back.
// Must read "glowing point of light with form hint," not cute insect.
// See docs/planning/firefly_visual_design.md §V1 (F4).

export type FireflyBugSvgProps = {
  /** Rendered width/height in px (square box). */
  sizePx: number;
  /** Body + wing fill — intent glow color (rgba ok). */
  fillColor: string;
};

/** Normalized 16×16 viewBox; wings sit behind the body. */
export function FireflyBugSvg({ sizePx, fillColor }: FireflyBugSvgProps) {
  return (
    <svg
      aria-hidden
      width={sizePx}
      height={sizePx}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block", overflow: "visible" }}
    >
      {/* Left wing — narrow, angled back-up */}
      <ellipse
        cx="4.8"
        cy="8.2"
        rx="3.1"
        ry="1.05"
        fill={fillColor}
        opacity={0.28}
        transform="rotate(-32 4.8 8.2)"
      />
      {/* Right wing */}
      <ellipse
        cx="11.2"
        cy="8.2"
        rx="3.1"
        ry="1.05"
        fill={fillColor}
        opacity={0.28}
        transform="rotate(32 11.2 8.2)"
      />
      {/* Abdomen / body — slightly taller oval */}
      <ellipse cx="8" cy="8.4" rx="2.15" ry="3.05" fill={fillColor} />
      {/* Head hint — small bright cap */}
      <ellipse cx="8" cy="5.55" rx="1.35" ry="1.15" fill={fillColor} opacity={0.92} />
    </svg>
  );
}

/** Bug SVG span relative to bodyDiameterPx from intent params. */
export function fireflyBugRenderSizePx(bodyDiameterPx: number): number {
  return Math.max(8, Math.round(bodyDiameterPx * 1.75));
}
